import React from 'react';
import { getIsProd } from 'utils/environment';
import Item from './Item';
import { defaultXl, defaultLg, defaultMd, defaultSm, defaultXsm } from './constants';

import * as styles from './Grid.module.scss';

const getColumnValue = (breakpoints, breakpointName) => {
  const defaults = { xl: defaultXl, lg: defaultLg, md: defaultMd, sm: defaultSm, xsm: defaultXsm };
  return breakpoints[breakpointName].cols ?? defaults[breakpointName].cols;
};

const getGutterValue = (breakpoints, breakpointName, globalValue, gutterType) => {
  const defaults = { xl: defaultXl, lg: defaultLg, md: defaultMd, sm: defaultSm, xsm: defaultXsm };
  return (
    breakpoints[breakpointName][gutterType] ?? globalValue ?? defaults[breakpointName][gutterType]
  );
};

const buildGridStyles = (breakpoints, globalGutterX, globalGutterY) => {
  return {
    '--columnsXl': getColumnValue(breakpoints, 'xl'),
    '--columnsLg': getColumnValue(breakpoints, 'lg'),
    '--columnsMd': getColumnValue(breakpoints, 'md'),
    '--columnsSm': getColumnValue(breakpoints, 'sm'),
    '--columnsXsm': getColumnValue(breakpoints, 'xsm'),
    '--gutterX-xl': getGutterValue(breakpoints, 'xl', globalGutterX, 'gutterX'),
    '--gutterX-lg': getGutterValue(breakpoints, 'lg', globalGutterX, 'gutterX'),
    '--gutterX-md': getGutterValue(breakpoints, 'md', globalGutterX, 'gutterX'),
    '--gutterX-sm': getGutterValue(breakpoints, 'sm', globalGutterX, 'gutterX'),
    '--gutterX-xsm': getGutterValue(breakpoints, 'xsm', globalGutterX, 'gutterX'),
    '--gutterY-xl': getGutterValue(breakpoints, 'xl', globalGutterY, 'gutterY'),
    '--gutterY-lg': getGutterValue(breakpoints, 'lg', globalGutterY, 'gutterY'),
    '--gutterY-md': getGutterValue(breakpoints, 'md', globalGutterY, 'gutterY'),
    '--gutterY-sm': getGutterValue(breakpoints, 'sm', globalGutterY, 'gutterY'),
    '--gutterY-xsm': getGutterValue(breakpoints, 'xsm', globalGutterY, 'gutterY'),
  };
};

const validateGridChildren = children => {
  if (getIsProd()) return;

  React.Children.forEach(children, child => {
    if (child && child.type !== Item && window) {
      window.console.log(
        '%c%s',
        'color: red; font: 1.2rem/1 sans-serif;',
        'Warning! Use GridItem to render Grid children.',
      );
    }
  });
};

export default function Grid({
  xsm = {},
  sm = {},
  md = {},
  lg = {},
  xl = {},
  gutterX,
  gutterY,
  children,
}) {
  const breakpoints = { xsm, sm, md, lg, xl };
  const style = buildGridStyles(breakpoints, gutterX, gutterY);

  validateGridChildren(children);

  return (
    <div className={styles.grid} style={style}>
      {children}
    </div>
  );
}
